import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import TextareaAutosize from 'react-autosize-textarea';
import update from 'immutability-helper';
import InvoiceHeader from '../Invoice/InvoiceHeader';
import LineItems from './LineItems';
import StickyRequestBanner from './StickyRequestBanner';
import { postRequest } from '../../requestUtils';
import { analyticsTrack } from '../../analyticsUtils';
import { sum, sumTime } from '../../arrayUtils';
import './RequestEditsInvoice.scss';
var RequestEditsInvoice = /*#__PURE__*/function (_Component) {
  function RequestEditsInvoice(props) {
    var _this;
    _classCallCheck(this, RequestEditsInvoice);
    _this = _callSuper(this, RequestEditsInvoice, [props]);
    var invoice = props.invoice;
    _this.state = {
      feedback: invoice.feedback,
      lineItems: invoice.line_items,
      showModal: false,
      isValid: true
    };
    _this.handleShowModal = _this.handleShowModal.bind(_this);
    _this.handleCloseModal = _this.handleCloseModal.bind(_this);
    _this.updateFeedback = _this.updateFeedback.bind(_this);
    _this.updateLineItemFeedback = _this.updateLineItemFeedback.bind(_this);
    _this.sendRequestEdit = _this.sendRequestEdit.bind(_this);
    return _this;
  }
  _inherits(RequestEditsInvoice, _Component);
  return _createClass(RequestEditsInvoice, [{
    key: "handleShowModal",
    value: function handleShowModal() {
      var _this$state = this.state,
        feedback = _this$state.feedback,
        lineItems = _this$state.lineItems;
      if (feedback || Object.values(lineItems).flat().some(function (li) {
        return li.feedback;
      })) {
        analyticsTrack('Clicked on Send Edits button to open request edits confirmation modal', {
          location: 'Invoices Edit'
        });
        this.setState({
          showModal: true
        });
      } else {
        analyticsTrack('Clicked on Send Edits button to open request edits confirmation modal', {
          location: 'Invoices Edit',
          error: 'Form was invalid'
        });
        this.setState({
          isValid: false
        });
      }
    }
  }, {
    key: "handleCloseModal",
    value: function handleCloseModal() {
      analyticsTrack('Cancelled Send Edits on request edits confirmation modal', {
        location: 'Invoices Edit'
      });
      this.setState({
        showModal: false
      });
    }
  }, {
    key: "updateFeedback",
    value: function updateFeedback(value) {
      this.setState({
        feedback: value,
        isValid: true
      });
    }
  }, {
    key: "updateLineItemFeedback",
    value: function updateLineItemFeedback(category, lineItemId, feedback) {
      var lineItems = this.state.lineItems;
      var lineItemIndex = lineItems[category].findIndex(function (a) {
        return a.id === lineItemId;
      });
      var newLineItems = update(lineItems, _defineProperty({}, category, _defineProperty({}, lineItemIndex, {
        $merge: {
          feedback: feedback
        }
      })));
      if (Object.values(lineItems).flat().some(function (li) {
        return li.feedback;
      })) {
        this.setState({
          isValid: true
        });
      }
      this.setState({
        lineItems: newLineItems
      });
    }
  }, {
    key: "sendRequestEdit",
    value: function sendRequestEdit() {
      var _this$props = this.props,
        invoice = _this$props.invoice,
        csrfToken = _this$props.csrfToken;
      var _this$state2 = this.state,
        feedback = _this$state2.feedback,
        lineItems = _this$state2.lineItems;
      var lineItemFeedbacks = Object.values(lineItems).flat().filter(function (li) {
        return li.feedback;
      }).map(function (li) {
        return {
          id: li.id,
          feedback: li.feedback
        };
      });
      postRequest("/invoices/".concat(invoice.resource_id, "/request_edits"), {
        invoice: {
          feedback: feedback,
          line_items_attributes: lineItemFeedbacks
        }
      }, csrfToken).then(function () {
        analyticsTrack('Confirmed Send Edits on request edits confirmation modal', {
          location: 'Invoices Edit'
        });
        window.location.href = "/invoices/".concat(invoice.resource_id);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        viewerIsEmployer = _this$props2.viewerIsEmployer,
        projectName = _this$props2.projectName,
        projectResourceId = _this$props2.projectResourceId,
        invoice = _this$props2.invoice,
        csrfToken = _this$props2.csrfToken,
        location = _this$props2.location,
        totals = _this$props2.totals,
        workCommitment = _this$props2.workCommitment,
        areaOfExpertises = _this$props2.areaOfExpertises,
        tags = _this$props2.tags,
        jobTitles = _this$props2.jobTitles,
        description = _this$props2.description,
        responsibilities = _this$props2.responsibilities,
        duration = _this$props2.duration,
        workLocation = _this$props2.workLocation,
        shortOfficeLocation = _this$props2.shortOfficeLocation,
        startDate = _this$props2.startDate,
        displayedLaborRate = _this$props2.displayedLaborRate,
        displayedTravelRate = _this$props2.displayedTravelRate;
      var _this$state3 = this.state,
        feedback = _this$state3.feedback,
        lineItems = _this$state3.lineItems,
        showModal = _this$state3.showModal,
        isValid = _this$state3.isValid;
      var consulting = lineItems.consulting,
        travel = lineItems.travel,
        expense = lineItems.expense;
      return /*#__PURE__*/React.createElement("div", {
        className: "invoice-request-edits"
      }, /*#__PURE__*/React.createElement(Modal, {
        show: showModal,
        onHide: this.handleCloseModal,
        size: "lg"
      }, /*#__PURE__*/React.createElement(Modal.Header, {
        closeButton: true,
        className: "no-border-bottom"
      }), /*#__PURE__*/React.createElement(Modal.Body, {
        className: "confirm-request-edit p-3 p-md-5"
      }, /*#__PURE__*/React.createElement("div", {
        className: "style-guide"
      }, /*#__PURE__*/React.createElement("h1", {
        className: "mb-5"
      }, "You are about to send your comments and request edits on this timesheet."), /*#__PURE__*/React.createElement("div", {
        className: "body-text-1 mb-5"
      }, invoice.consultant_name, ' ', "will receive your comments and will address them. Expect to receive the edited timesheet for approval in the next few days."), /*#__PURE__*/React.createElement("div", {
        className: "d-flex flex-column flex-md-row gap-3"
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-secondary standard-button g-flex-fill me-2",
        onClick: this.handleCloseModal
      }, "No, go back to edits"), /*#__PURE__*/React.createElement("button", {
        className: "btn btn-primary standard-button g-flex-fill",
        onClick: this.sendRequestEdit
      }, "Yes, Send & Request"))))), /*#__PURE__*/React.createElement(StickyRequestBanner, {
        resourceId: invoice.resource_id,
        isValid: isValid,
        consultantName: invoice.consultant_name,
        handleShowModal: this.handleShowModal
      }), /*#__PURE__*/React.createElement("div", {
        className: "container"
      }, /*#__PURE__*/React.createElement(InvoiceHeader, {
        invoiceNumber: invoice.invoice_number,
        id: invoice.resource_id,
        abbreviatedMonth: invoice.abbreviated_month,
        month: invoice.month,
        year: invoice.year,
        status: "requesting_edits",
        projectResourceId: projectResourceId,
        projectName: projectName,
        consultantName: invoice.consultant_name,
        memo: invoice.memo,
        totals: totals,
        csrfToken: csrfToken,
        location: location,
        feedback: invoice.feedback,
        editsRequestedBy: invoice.edits_requested_by,
        editsRequestedOn: invoice.edits_requested_on,
        approvedBy: invoice.approved_by,
        approvedOn: invoice.approved_on,
        isProjectTeamMember: true,
        workCommitment: workCommitment,
        areaOfExpertises: areaOfExpertises,
        tags: tags,
        jobTitles: jobTitles,
        description: description,
        responsibilities: responsibilities,
        duration: duration,
        workLocation: workLocation,
        shortOfficeLocation: shortOfficeLocation,
        startDate: startDate,
        buttonStyles: "body-text-1",
        showHourWarning: false,
        projectedHours: invoice.projected_hours_by_consultants
      }, /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 invoice-request-edit ".concat(isValid ? '' : 'not-valid')
      }, /*#__PURE__*/React.createElement("div", {
        className: "demibold mb-5"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-edit"
      }), "Request general edits here:"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TextareaAutosize, {
        name: "general-request-edit",
        className: "general-request-edit",
        placeholder: "Add general edits requests for the consultant here...",
        value: feedback,
        onChange: function onChange(e) {
          return _this2.updateFeedback(e.target.value);
        },
        rows: 2
      })))), /*#__PURE__*/React.createElement(LineItems, {
        lineItems: consulting,
        lineItemsGroupName: "Consulting Hours - $".concat(displayedLaborRate, "/hr"),
        descriptionLabel: "Task Description",
        category: "consulting",
        hasDuration: true,
        viewerIsEmployer: viewerIsEmployer,
        rate: displayedLaborRate,
        totalPay: sum(consulting, viewerIsEmployer),
        totalTime: sumTime(consulting),
        updateLineItemFeedback: this.updateLineItemFeedback,
        isValid: isValid
      }), /*#__PURE__*/React.createElement(LineItems, {
        lineItems: travel,
        lineItemsGroupName: "Travel Hours - $".concat(displayedTravelRate, "/hr"),
        descriptionLabel: "Travel Description",
        category: "travel",
        hasDuration: true,
        viewerIsEmployer: viewerIsEmployer,
        rate: displayedTravelRate,
        totalPay: sum(travel, viewerIsEmployer),
        totalTime: sumTime(travel),
        updateLineItemFeedback: this.updateLineItemFeedback,
        isValid: isValid
      }), /*#__PURE__*/React.createElement(LineItems, {
        lineItems: expense,
        lineItemsGroupName: "Expenses",
        descriptionLabel: "Expense Description",
        category: "expense",
        totalPay: sum(expense, viewerIsEmployer),
        updateLineItemFeedback: this.updateLineItemFeedback,
        isValid: isValid
      })));
    }
  }]);
}(Component);
RequestEditsInvoice.propTypes = {
  viewerIsEmployer: PropTypes.bool.isRequired,
  invoice: PropTypes.shape({}).isRequired,
  projectName: PropTypes.string.isRequired,
  projectResourceId: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  totals: PropTypes.shape({}).isRequired,
  workCommitment: PropTypes.number.isRequired,
  areaOfExpertises: PropTypes.arrayOf(PropTypes.string),
  tags: PropTypes.arrayOf(PropTypes.string),
  jobTitles: PropTypes.string,
  description: PropTypes.string.isRequired,
  responsibilities: PropTypes.arrayOf(PropTypes.string).isRequired,
  duration: PropTypes.string.isRequired,
  workLocation: PropTypes.string.isRequired,
  shortOfficeLocation: PropTypes.string.isRequired,
  startDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  displayedLaborRate: PropTypes.number.isRequired,
  displayedTravelRate: PropTypes.number.isRequired
};
RequestEditsInvoice.defaultProps = {
  areaOfExpertises: [],
  tags: [],
  jobTitles: '',
  startDate: null
};
export default RequestEditsInvoice;